import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import ChartComponent from "../Highcharts/ChartComponent";
import { reportBarConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function AllReportedCountryCases({ requestData }) {
  const [chartCounter, setChartCounter] = useState(null);
  const [showAllLabel, setShowAllLabel] = useState(false);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      userIdentifier: "County",
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getCountiesData(oRequest);
      }
    } else {
      getCountiesData(requestBody);
    }
  }, [requestData]);

  let getCountiesData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/countiesOrUserTypeReportingCases `,
        data
      );
      let formatedData = res.data.data;
      let sortedArray = Object.entries(formatedData).sort(
        (a, b) => b[1] - a[1]
      );

      let sortedFormatedData = Object.fromEntries(sortedArray);
      let catagoriesArr = Object.keys(sortedFormatedData);
      let chartValues = Object.values(sortedFormatedData);
      let percentValues = [];

      Object.keys(sortedFormatedData).forEach((key, index) => {
        let percentVal;
        if (
          sortedFormatedData[key] !== 0 &&
          totalValue(sortedFormatedData) !== 0
        ) {
          percentVal = Math.round(
            (sortedFormatedData[key] / totalValue(sortedFormatedData)) * 100
          );
        } else {
          percentVal = 0;
        }
        let obj = {
          percent: percentVal,
          y: sortedFormatedData[key],
        };
        percentValues = [...percentValues, obj];
      });

      let obj = {
        catagoriesArr,
        percentValues,
      };
      setChartCounter(obj);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSwitch = () => {
    setShowAllLabel((prev) => !prev);
  };

  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };
  return (
    <Card>
      <Card.Body className="pb-3">
        <Row className="secsevenheading">
          <Col lg={10}>
            <h5>Distribution of reported all reported cases by county</h5>
          </Col>
          <Col lg={2} className="swithcBtn">
            <div className="secseventext">Show Counties</div>
            <Form>
              <Form.Check // prettier-ignore
                type="switch"
                id="custom-switch"
                value={showAllLabel}
                onChange={(e) => {
                  handleSwitch();
                  console.log("e>>", e.target.value);
                }}
              />
            </Form>
          </Col>
        </Row>

        {chartCounter !== null ? (
          <ChartComponent
            options={reportBarConfig(chartCounter, showAllLabel)}
          />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default AllReportedCountryCases;
